import { createContext, use } from 'react';
import type { UseDropdownTreeResult } from '../hooks/useDropdownTree';
import type { DropdownV3BaseProps } from '../types';

type DropdownContextValue = UseDropdownTreeResult &
  Required<
    Pick<
      DropdownV3BaseProps,
      | 'loading'
      | 'multiple'
      | 'searchable'
      | 'expandable'
      | 'defaultExpanded'
      | 'label'
      | 'triggerPlaceholder'
      | 'searchPlaceholder'
      | 'searchNoResultsText'
      | 'searchClearLabel'
      | 'selectAllLabel'
      | 'allSelectedLabel'
      | 'selectedValuesDisplay'
    >
  > &
  Pick<
    DropdownV3BaseProps,
    'countSelectedGroups' | 'renderItemContent' | 'headerContent' | 'error' | 'required'
  > & {
    dataTestId?: string;
  };

export const DropdownContext = createContext<DropdownContextValue | null>(null);

export function useDropdownContext() {
  const context = use(DropdownContext);

  if (!context) {
    throw new Error('useDropdownContext must be used inside DropdownContext');
  }

  return context;
}
